import React, {useRef, useCallback} from "react";
import Loader from "./Loader";
import {LoaderContext} from "./LoaderContext";

const LoaderProvider = ({children}) => {
  const loaderRef = useRef(null);

  const showLoader = useCallback(() => {
    loaderRef.current?.play();
  }, []);

  return (
    <LoaderContext.Provider value={{showLoader}}>
      <Loader ref={loaderRef} />
      {children}
    </LoaderContext.Provider>
  );
};

export default LoaderProvider;
